// extracted by mini-css-extract-plugin
export var clickableWrapper = "_36-2";
export var placeholderIcon = "_36-3";
export var thumbnailCanvas = "_36-1";
export var thumbnailWrapper = "_36-0";